import { Box, styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import { TEXT_ELLIPSIS } from "../../Shared/styles";

export const ModalContentBox = styled(Box)({
    minHeight: "100%",
    padding: "0",
    height: "100%",
});

export const ModalTitleTypography = styled(Typography)({
    fontWeight: "700",
    fontSize: "14px",
    "@media (min-width: 640px)": {
        fontSize: "16px",
    },
    ...TEXT_ELLIPSIS,
});
